import React from "react";
import Stack from "@mui/material/Stack";
import Item from "../../../Template/Item";
import Button from "@mui/material/Button";

import { IScheduleEvent } from "../../../redux/reducers/schedule.reducer";
import { useTheme } from "@mui/material";
import {
  IFacilityOption,
  eventForm,
} from "../../CalendarForms/Types/calendarTypes";

type DayPropsType = {
  date: string;
  allEvents: IScheduleEvent[];
  fullDate: string;
  dayString: string;
  setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedEvent: React.Dispatch<React.SetStateAction<IScheduleEvent | null>>;
  setShowingEventForm: React.Dispatch<React.SetStateAction<eventForm>>;
  selectedFacility: IFacilityOption | null;
  filterByWorktype: string[];
  setShowAssignEmployeeModal: React.Dispatch<React.SetStateAction<boolean>>;
};
export default function WeekHead(props: DayPropsType) {
  const { dayString, date, fullDate, setShowingEventForm } = props;
  const customTheme = useTheme();

  function handleAddEventClick() {
    setShowingEventForm({ visible: true, preselectedDate: fullDate });
  }
  // for checking previous days
  // let nowDate = new Date();
  // let scheduleDate = new Date(`${fullDate}T23:59:59`);
  // let isEventAddable = !!(nowDate <= scheduleDate);

  let currentDate = new Date();
  let renderDate = new Date(fullDate);
  let isTodya = false;
  if (
    currentDate.getFullYear() === renderDate.getFullYear() &&
    currentDate.getMonth() === renderDate.getMonth() &&
    currentDate.getDate() === renderDate.getDate()
  )
    isTodya = true;

  return (
    <Stack spacing={2} sx={{ width: "14.28%" }}>
      <Item sx={{ whiteSpace: "nowrap", overflow: "hidden" }}>
        <span
          style={{
            padding: "5px",
            borderRadius: "50%",
            backgroundColor: isTodya ? customTheme?.palette?.primary?.main : "",
            color: isTodya ? "white" : "",
          }}
        >
          {date}
        </span>
        {dayString}
      </Item>

      <Item>
        <Button
          // disabled={isEventAddable ? false : true}

          size="small"
          color="primary"
          variant="contained"
          onClick={() => handleAddEventClick()}
          sx={{ width: "100%", minWidth: "100%" }}
        >
          +
        </Button>
      </Item>
    </Stack>
  );
}
